import Table from 'components/Display/Table/Table'
import Tabs from 'components/Display/Tabs/Tabs'
import Page from 'components/Page/Page'
import useInvites from 'logic/Invites/useInvites'
import useUsers from 'logic/Users/useUsers'
import React, {useCallback, useMemo, useState} from 'react'
import ManagePermissionsMenuItem from 'components/Control/ActionMenuItem/ManagePermissionsMenuItem'
import LockRoundedIcon from '@mui/icons-material/LockRounded'
import UserPermissionsDialog from 'components/Modal/UserPermissionsDialog'
import tableActions from 'constants/tableActions'
import {
    useCreateUserMutation,
    useDeleteUserMutation,
    useEditUserMutation,
    useGetUserQuery,
    useGetUsersQuery,
} from 'store/Store'
import {
    useCreateInviteMutation,
    useDeleteInviteMutation,
    useEditInviteMutation,
    useGetInviteQuery,
    useGetInvitesQuery,
} from 'store/slices/api/invitesApi'

const Users = () => {
    const [permissionsUser, setPermissionsUser] = useState(null)
    const handleOpenPermissions = useCallback((row) => {
        setPermissionsUser(row)
    }, [])
    const handleClosePermissions = useCallback(() => setPermissionsUser(null), [])

    const usersTableActions = useMemo(
        () => [
            {
                MenuItem: ManagePermissionsMenuItem,
                title: 'manage_permissions',
                Icon: LockRoundedIcon,
                onOpen: handleOpenPermissions,
            },
        ],
        [handleOpenPermissions]
    )

    const tabs = useMemo(
        () => [
            {
                title: 'users',
                translation: 'users',
                content: (
                    <Table
                        itemName="user"
                        paginationType="external"
                        allowDelete
                        allowEdit
                        allowExpanded
                        useEditMutation={useEditUserMutation}
                        useGetQuery={useGetUsersQuery}
                        useGetByIdQuery={useGetUserQuery}
                        useCreateMutation={useCreateUserMutation}
                        useDeleteMutation={useDeleteUserMutation}
                        useModal={useUsers}
                        tableHeight={88}
                        tableActions={usersTableActions}
                    />
                ),
            },
            {
                title: 'invites',
                translation: 'users',
                content: (
                    <Table
                        itemName="invite"
                        paginationType="external"
                        allowDelete
                        allowEdit
                        allowExpanded
                        allowCreate
                        useEditMutation={useEditInviteMutation}
                        useGetQuery={useGetInvitesQuery}
                        useGetByIdQuery={useGetInviteQuery}
                        useCreateMutation={useCreateInviteMutation}
                        useDeleteMutation={useDeleteInviteMutation}
                        useModal={useInvites}
                        tableHeight={88}
                        tableActions={tableActions.inviteTableActions}
                    />
                ),
            },
        ],
        [usersTableActions]
    )

    const selectedUserId = permissionsUser?._id || permissionsUser?.id || permissionsUser?.key

    return (
        <Page>
            <Tabs tabs={tabs} />
            <UserPermissionsDialog
                open={Boolean(permissionsUser)}
                onClose={handleClosePermissions}
                userId={selectedUserId}
                userSummary={permissionsUser}
            />
        </Page>
    )
}

export default Users
